export enum Menu {
    AccountPreferences,
    BrokerDetails,
    CustomerContactDetails,
    Hamburger,
    Language,
    AccountNotifications,
}
export interface MenuState {
    currentlyOpenMenu: Menu | undefined;
}
